import AuthService from "../services/AuthService";
import FileService from "../services/FileService";
import CompanyModel from "../models/CompanyModel";
import CompanyService from "../services/CompanyService";

class CompanyController {
  async createCompany(name: string, logo?: File) {
    const userUid = AuthService.currentUserId;
    const newCompany = CompanyModel.createBlank(userUid);
    newCompany.name = name;

    const createdUid = await CompanyService.createCompany(newCompany);
    const company = CompanyModel.create(createdUid, { ...newCompany });
    if (logo) {
      await this.uploadLogo(company, logo);
      await CompanyService.updateCompanyLogo(company);
    }
  }

  async updateCompany(company: CompanyModel, name: string, logo?: File) {
    if (logo) {
      await this.uploadLogo(company, logo);
    } else {
      company.image = "";
    }

    company.name = name;
    return CompanyService.updateCompany(company);
  }

  private async uploadLogo(company: CompanyModel, file: File) {
    const path = `images/company/${company.uid + file.name}`;
    const newPath = await FileService.upload(file, path);
    if (newPath) {
      company.image = newPath;
    }
  }
}

export default new CompanyController();
